import { convertToError } from 'API/BaseApi';
import { IFetchDataState } from 'store/IFetchDataState';
import {
  createDefaultFetch,
  createFetchInProgress,
  createFetchedSuccess,
  createFetchedWithError,
} from 'types/rest/IFetchStatus';

export interface ICreateIFetchDataStateFromPieces<Data, Query> {
  hookData: { data?: Data; isFetching: boolean; isSuccess: boolean; error?: any };
  query: Query;
  defaultData: Data;
}
export const createIFetchDataStateFromPieces = <Data, Query>({
  hookData,
  query,
  defaultData,
}: ICreateIFetchDataStateFromPieces<Data, Query>): IFetchDataState<Query, Data> => {
  const errorFetch = hookData.error ? createFetchedWithError() : createDefaultFetch();
  const successFetch = hookData.isSuccess ? createFetchedSuccess() : errorFetch;
  const fetchStatus = hookData.isFetching ? createFetchInProgress() : successFetch;
  const fetchError = convertToError(hookData.error);
  return { data: hookData.data ?? defaultData, query, fetchStatus, fetchError };
};
